export default __webpack_public_path__ + "static/media/AMPL.4af0aaba.png";